import React, { useMemo } from 'react';

import { isGoGameEnv } from 'App/constants';
import { AnnotationsKnob } from 'components/ChartTools/Annotations';

import { useScreenState } from '@gogame/screens';

import { useChartState } from '../hooks';

export const AnnotationsAction = ({ id }) => {
  const chartState = useChartState();
  const screenState = useScreenState();
  const chartType = chartState.chartViewSettings.type;

  const canUseAnnotations = useMemo(() => {
    return (
      screenState.charts.length === 1 &&
      screenState.filtersCollection.length === 1 &&
      isGoGameEnv
    );
  }, [screenState.charts.length, screenState.filtersCollection.length]);

  if (!canUseAnnotations) {
    return null;
  }

  return (
    <AnnotationsKnob
      showAnnotations={chartState.annotations.showAnnotations}
      id={id}
      disabled={chartType === 'pie'}
    />
  );
};
